import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import { getRouteByName } from 'Helpers/Routes';

import Head from 'Components/helpers/Head';

@connect(
    (state) => ({}), {}
)
export default class Careers extends React.Component {
    static propTypes = {
        params: PropTypes.shape({
            slug: PropTypes.string
        })
    };
    static defaultProps = {};

    offers = [];

    state = {
        activeOffer: null
    };

    setActiveOffer = offer => {
        this.setState({
            ...this.state,
            activeOffer: offer.component
        }, () => {
            browserHistory.push(getRouteByName('careers', { slug: offer.slug }).path);

            setTimeout(() => {
                const offerPosition = document.getElementById('active-offer').getBoundingClientRect();
                window.scroll({ top: offerPosition.top + document.documentElement.scrollTop - 100, behavior: 'smooth' });
            }, 100);
        });
    }

    componentDidMount = () => {
        const { slug } = this.props.params;

        if (slug) {
            const offerIndex = this.offers.findIndex(offer => offer.slug === slug);
            if (offerIndex > -1) {
                this.setActiveOffer(this.offers[offerIndex]);
            }
        }
    }

    render() {
        const { activeOffer } = this.state;

        return (
            <div className="container-careers">
                <Head
                    title={`Careers`}
                    description={``}
                    robots={`index, follow`}
                    canonical={getRouteByName('careers').path}
                />
                <div className="container-fluid">
                    <header className="careers-header">
                        <h1 className="careers-headline">Want to join us?</h1>
                        <p className="carrers-description">
                            The power of crowdsourcing talent, passion, and branding ideas among 3MM visual content creators is
                            our daily bread here at FOAP.
                            We stimulate the creativity of a global community of photo and videography enthusiasts worldwide to
                            create curated, legally covered, on-brand and engaging visual content for all digital marketing needs.
                            By making possible for creatives to commercialize their snaps, we bring to the industry something new and fresh.
                            Traditional stock photography and videography feels just wrong. It’s boring, fake, staged, artificial.
                            Our global community of photo and video-creatives is taking snaps of their everyday lives, of real moments.
                            That’s why our visual content is more likable and create more engagement, not least on social media.
                            Since our launch in 2012, we’ve created thumb-stopping photos and videos for Google, Heineken, Volvo Group,
                            Pernod Ricard, MasterCard, VisitSweden, Sony, Lufthansa, Priceline, VisitEngland and many, many more.
                            <br /><br />
                            Join to the world of the real visual content marketing!
                        </p>
                    </header>
                    <div className="careers-offers-list">
                        {
                            this.offers.map((offer, slug) => (
                                <a className="career-offer" key={offer.slug} onClick={() => this.setActiveOffer(offer)}>
                                    <h2 className="offer-name">{offer.name}</h2>
                                    <p className="offer-location">{offer.location}</p>
                                </a>
                            ))
                        }
                    </div>
                    {activeOffer ?
                        <div className="active-offer-container" id="active-offer">
                            {activeOffer}
                        </div>
                        : null}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/global/Careers/index.js